import { createUseStyles } from 'react-jss';

const styles = {
  confirmationDialog: {
    minWidth: '22rem'
  },
  confirmationHeader: {
    marginTop: '0.3rem',
    marginBottom: '0.3rem'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '0.5fr 3fr',
    gridTemplateRows: '3fr 1fr',
    gridTemplateAreas: `
      "action-label actions"
      "language-label languages"
    `,
    gap: '0.5rem'
  },
  label: {
    alignItems: 'center',
    textAlign: 'right'
  },
  actionLabel: {
    composes: '$label',
    gridArea: 'action-label'
  },
  languageLabel: {
    composes: '$label',
    gridArea: 'language-label'
  },
  actions: {
    gridArea: 'actions'
  },
  languages: {
    gridArea: 'languages',
    display: 'flex',
    alignItems: 'center',
    '& ui5-select': {
      width: '100%'
    }
  },
  dialogFooter: {
    boxShadow: 'none'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'CompleteDistributionDialog'
});
